import { render, staticRenderFns } from "./iframe.vue?vue&type=template&id=4ce237b1&scoped=true&"
import script from "./iframe.vue?vue&type=script&lang=js&"
export * from "./iframe.vue?vue&type=script&lang=js&"
import style0 from "./iframe.vue?vue&type=style&index=0&id=4ce237b1&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce237b1",
  null
  
)

export default component.exports